import InternalLinking from './InternalLinking';

export default InternalLinking;
